/**
 * Created by istvan.rozsa on 2017. 03. 26..
 */

export default function (app) {
	app.directive('autoFocus', function ($timeout) {
		return {
			restrict: 'A',
			link: function (_scope, _element) {
				$timeout(function () {
					_element[0].focus();
				}, 0);
			}
		};
	});
};
